import useModalHeaderHeight from "@memorang/ui/hooks/useModalHeaderHeight";
import { useRouter } from "expo-router";
import { Appbar } from "react-native-paper";

type Props = {
	headerTitle?: string;
	backIcon?: string;
	headerRight?: () => React.ReactNode;
};
const ModalHeader = ({ headerTitle, backIcon, headerRight }: Props) => {
	const router = useRouter();

	const statusBarHeight = useModalHeaderHeight();
	return (
		<Appbar.Header
			statusBarHeight={statusBarHeight}
			mode="center-aligned"
			elevated
		>
			<Appbar.Action onPress={() => router.back()} icon={backIcon || "close"} />
			<Appbar.Content title={headerTitle || ""} />
			{headerRight?.()}
		</Appbar.Header>
	);
};
export default ModalHeader;
